import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  data: []
};

export const orderSliceDB = createSlice({
  name: 'orderSlicedb',
  initialState,
  reducers: {
    getOrderListDB: (state) => {
      state.loading = true;
      state.error = null;
    },
    getOrderDeatilsDB: (state) => {
      state.loading = true;
      state.error = null;
    },
    addOrderListDB: (state) => {
      state.loading = true;
      state.error = null;
    },
    removeOrderListDB: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateOrderListDB: (state) => {
      state.loading = true;
      state.error = null;
    },
    successOrderListDB: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
      state.callTimes += 1;
    },
    failedOrderListDB: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const {
  getOrderListDB,
  getOrderDeatilsDB,
  addOrderListDB,
  removeOrderListDB,
  updateOrderListDB,
  successOrderListDB,
  failedOrderListDB
} = orderSliceDB.actions;

export default orderSliceDB.reducer;
